<div class="timeline">
  @for (item of timeLineItems(); track $index) {
    <div class="timeline__item-container">
      <app-time-line-item [label]="item.label" [classes]="item.classes" />
    </div>
  }
</div>
